export default "__VITE_ASSET__CzY4qqac__"